import TenIntoTenIcon from 'assets/images/psp/ATV/10x10.svg';
import TenIntoFifteenIcon from 'assets/images/psp/ATV/10x15.svg';
import TenIntoTwentyIcon from 'assets/images/psp/ATV/10x20.svg';
import ATV from 'assets/images/psp/ATV/atv.webp';
import PreParingATV from 'assets/images/psp/ATV/preparing-atv-for-storage.webp';
import ATVHeroSize from 'assets/images/psp/ATV/atv-hero-size.webp';
import MotorCycle from 'assets/images/psp/FeaturedContentImages/motorcycle.webp';
import CarStorage from 'assets/images/psp/FeaturedContentImages/car-storage-guide.webp';
import MotorCycleWinter from 'assets/images/psp/FeaturedContentImages/motorcycle-storage.webp';
import ShuterStock from 'assets/images/psp/ATV/shutterstock.webp';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const reviews = [
	{
		title: 'Evan Provided Great Customer Service',
		stars: 5,
		text: 'Evan was really wonderful to work with. I have very little experience in rented storage space, and even less in renting a storage space for a motorcycle. Evan assisted in making sure I had the proper size and location.',
		customerName: 'Erin',
		date: 'Jul 23, 2024',
		link: 'https://www.trustpilot.com/reviews/669fcb02e405d59061446523',
	},
	{
		title: 'It was a very nice and pleasant experience',
		stars: 5,
		text: 'It was a very nice and pleasant experience. Staff was very professional and helpful. Storage space was clean and just what was needed for parking my motorcycle. The price is very much right on queue with every one else, maybe even a few dollars cheaper than the rest.',
		customerName: 'Preston Newberry',
		date: 'Jun 17, 2020',
		link: 'https://www.trustpilot.com/reviews/5ee92e067dd7530708856a5c',
	},
	{
		title: 'Best 1st Impression',
		stars: 5,
		text: 'I have had multiple units in the past but this was by far the best. The rep was able to search for a location fitting my needs and booked me an appointment the same day. I showed up and the associates at Smart Shop Self Storage in Huntington Beach were extremely nice and helpful. I was able to get the perfect unit to store my motorcycle, and it was very affordable! Best first impression I’ve had to date.',
		customerName: 'Anthony Hainsworth',
		date: 'Oct 23, 2019',
		link: 'https://www.trustpilot.com/reviews/5daf9ec16048580988adc0f0',
	},
	{
		title: 'This site is awesome!',
		stars: 5,
		text: 'This site is awesome. I needed to store my motorcycle for the winter and of course, like most people I waited till the last minute to do so. spent a couple hours running around town only to find out that no one had available units. Jumped on selfstorage.com and found the perfect unit in minutes. Saved me a bunch of time and energy. Great site',
		customerName: 'Ron Yoak',
		date: 'Nov 20, 2018',
		link: 'https://www.trustpilot.com/reviews/5bf444779d3780035820669e',
	},
];

const atvStorageFAQs = [
	{
		question: 'Can you store an ATV in a storage unit?',
		answer: 'Absolutely! ATVs are commonly stored in both indoor and outdoor storage units. Most storage facilities welcome recreational vehicles, and many specialize in ATV and motorcycle storage. Just verify that your chosen facility allows recreational vehicles and has appropriate unit sizes for your four wheeler.',
	},
	{
		question: 'What size storage unit do I need for my ATV?',
		answer: "Most single ATVs fit comfortably in a 10x10 storage unit with room for basic accessories. If you have a larger four wheeler, extensive gear, or multiple ATVs, consider a 10x15 or 10x20 unit. Measure your ATV's length, width, and height, then add extra space for maneuvering and gear storage.",
	},
	{
		question: 'How much does ATV storage cost?',
		answer: "ATV storage costs vary by location and storage type, typically ranging from $35-$200 per month. Outdoor storage is the most budget-friendly option ($35-$85), covered storage offers moderate protection ($50-$125), and indoor storage provides maximum protection ($75-$200). Compare local options using **SelfStorage.com's** search tool.",
	},
	{
		question: 'Do I need special insurance for stored ATVs?',
		answer: 'Check with your insurance provider about coverage during storage periods. Many policies offer reduced rates for stored vehicles, and some storage facilities provide additional coverage options. Always verify that your ATV is covered for both theft and damage while in storage.',
	},
	{
		question:
			"What's the best 4 wheeler storage box for gear organization?",
		answer: 'Look for weatherproof 4 wheeler storage boxes with secure latching systems and adequate size for your gear. Popular options include lockable dry boxes for electronics and documents, and larger utility boxes for helmets and riding accessories. Choose UV-resistant materials for outdoor storage situations.',
	},
	{
		question: 'How often should I check on my stored ATV?',
		answer: 'Visit your stored ATV at least monthly to check tire pressure, battery condition, and overall security. Seasonal storage periods may require more frequent visits, especially during preparation and retrieval times. Regular check-ins help identify any issues before they become costly problems.',
	},
	{
		question: 'Can I access my ATV storage unit anytime?',
		answer: 'Access hours vary by storage facility. Many offer extended hours or 24/7 access, while others have specific operating hours. Choose a facility with access hours that match your riding schedule, especially if you prefer early morning or evening rides.',
	},
	{
		question: 'What should I avoid storing with my ATV?',
		answer: "Don't store gasoline, propane, or other hazardous materials in your storage unit. Remove any food items that could attract pests, and avoid storing important documents without proper weatherproof protection. Check your facility's specific restrictions before storing additional items with your four wheeler.",
	},
];

export const ATVContent = {
	type: 'ATV',
	reviews: reviews,
	sections: [
		{
			title: 'ATV Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'atv-storage-hero',
					props: {
						content: {
							title: 'Find Affordable ATV Self Storage',
							description:
								"Tired of your ATV taking up precious garage space or sitting exposed to the elements in your driveway? You're not alone. Many ATV owners struggle with finding adequate storage that keeps their investment protected while freeing up space at home for the things that matter daily.\n\n" +
								'Professional ATV storage offers the perfect solution – it protects your four wheeler from weather damage, theft, and seasonal wear while giving you back your garage, driveway, or shed space.\n\n' +
								'With **SelfStorage.com’s** easy search tool, you can find budget-friendly storage options that keep your ATV ready for your next adventure without the hassle of home storage headaches.',
							image: ATVHeroSize,
							CTAtext: 'Find ATV Self Storage',
						},
					},
				},
			],
		},

		{
			title: 'Understanding ATV Storage Unit Sizes',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Understanding ATV Storage Unit Sizes',
						description:
							'Here’s a quick breakdown of the different ATV self storage options available to riders like you:',
						cardData: [
							{
								title: '10x10',
								content:
									'**Best for:** Single ATVs, compact four wheelers, plus basic accessories and gear\n\n' +
									'**Square Footage:** 100 sq ft\n\n' +
									'**What Fits:** One standard ATV, helmets, protective gear, small maintenance tools\n\n' +
									'**Perfect If:** You have one ATV and minimal accessories',
								imageSrc: TenIntoTenIcon,
								contentAlign: 'text-left',
							},
							{
								title: '10x15',
								content:
									'**Best for:** Larger ATVs or multiple smaller four wheelers with gear storage\n\n' +
									'**Square Footage:** 150 sq ft\n\n' +
									'**What Fits:** One large ATV or two compact ATVs, multiple helmets, riding gear, basic maintenance supplies\n\n' +
									'**Perfect If:** You have a larger four wheeler or want extra space for organization',
								imageSrc: TenIntoFifteenIcon,
								contentAlign: 'text-left',
							},
							{
								title: '10x20',
								content:
									'**Best for:** Multiple ATVs, extensive gear collection, or ATV plus trailer storage\n\n' +
									'**Square Footage:** 200 sq ft\n\n' +
									'**What Fits:** 2-3 ATVs, trailer, complete riding gear for family, maintenance equipment, seasonal accessories\n\n' +
									"**Perfect If:** You're storing for the whole family or have a complete ATV setup",
								imageSrc: TenIntoTwentyIcon,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		// Video Content Section

		{
			title: 'ATV Storage Options',
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					props: {
						content: {
							title: 'ATV Storage Options',
							imageSrc: ATV,
							description:
								'The right storage solution for your ATV depends on your specific needs and budget. Many ATV owners are surprised to learn that professional storage often costs less than the potential damage from leaving their four wheeler exposed to the elements.',
							suffixText: `Indoor storage protects against rust and weather damage, covered storage offers a middle-ground for budget-conscious families, and outdoor storage provides maximum accessibility for frequent riders. The key is matching your storage choice to how often you ride and your local climate conditions.\n\n`,
						},
					},
				},
			],
		},

		// Video Content Section
		{
			title: 'Preparing Your ATV for Storage',
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					props: {
						content: {
							title: 'Preparing Your ATV for Storage',
							imageSrc: PreParingATV,
							description:
								'Proper preparation is crucial for keeping your four wheeler in peak condition during storage periods.',
							suffixText: `Whether you're storing for winter months or just need your ATV out of the way temporarily, following these preparation steps protects your investment and ensures you're ready to ride when storage time ends.`,
						},
					},
				},
			],
		},

		//Reviews Section
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							slug: 'business-reviews',
							headerTitle: 'ATV Self Storage: ',
							reviews: reviews,
						},
					},
				},
			],
		},

		// FAQs
		{
			title: 'ATV Self Storage FAQs',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'ATV Self Storage FAQs',
							faqs: atvStorageFAQs,
						},
					},
				},
			],
		},

		// Related COntent
		{
			title: 'Featured Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Related Content',
							data: {
								slug: 'ATV-featured-content',
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/small-vehicle-storage-guide',
										layout: false,
										plain: true,
										date: 'October 16, 2025',
										image: MotorCycle,
										content:
											'Small Vehicle Storage: How to Store Motorcycles, ATVs, and Golf Carts',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/car-storage-size-guide',
										layout: false,
										plain: true,
										date: 'March 3, 2025',
										image: CarStorage,
										content:
											'Choosing the Right Storage Unit for Your Vehicle',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/guide-to-motorcycle-winter-storage/',
										layout: false,
										plain: true,
										date: 'November 4, 2025',
										image: MotorCycleWinter,
										content:
											'Quick Guide to Proper Motorcycle Winter Storage',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/outdoor-gear-shed-storage-unit/',
										layout: false,
										plain: true,
										date: 'October 16, 2025',
										image: ShuterStock,
										content:
											'Sports Equipment Storage Guide: How to Create A Sports and Outdoor Gear Storage Room',
									},
								],
							},
						},
					},
				},
			],
		},

		// More Ways to Store
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						linksList: storageCategories.atv,
					},
				},
			],
		},

		// Near By cities
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'ATV',
					},
				},
			],
		},
	],
};
